import { Component, OnInit } from '@angular/core';
import { MenuServiceInt } from '@core/_services/menu.serviceint';
import { ItemConfirmComponent } from '../_components/item-confirm/item-confirm.component';
import { MessagesService } from '@core/_services/messages.service';
import { ConfirmationService } from 'primeng/api';
import { SelectItem } from 'primeng/api';
import { dateFormat, setFormRangeData, setRangeDate } from '@core/_utils/date.utils';
import { CommonService } from '@service/common.service';
import { LayoutService } from '../../layout/service/app.layout.service';
import { TranslateService } from '@ngx-translate/core';
import { AuthService } from '@auth/auth.service';
import {getExportFileName, prepareExportExcel} from '@core/_utils/tools.utils';
import { lastValueFrom } from 'rxjs';
import { ApiV6Service } from '@service/apiv6.service';
import {DownloadService} from "@service/download.service";

@Component({
    selector: 'page-log-track',
    templateUrl: './page-log-track.component.html',
    styleUrls: ['./page-log-track.component.scss'],
})
export class PageLogTrackComponent implements OnInit {
    public trackLog = [];
    public isDesktop: boolean = false;
    public error = false;
    public itemConfirm: ItemConfirmComponent;
    public stateList: SelectItem[];
    
    public isAdmin: boolean = false;
    public listColumns = [];
    public selectedAction: Number;
    public visible: boolean = false;
    public rangeDates: Date[] | undefined;

    constructor(
        public menu: MenuServiceInt,
        private api: ApiV6Service,
        protected _messageService: MessagesService,
        public confirmationService: ConfirmationService,
        private commonService: CommonService,
        private main: LayoutService,
        private translate: TranslateService,
        private auth: AuthService,
        private downloadService: DownloadService
    ) {
        this.menu.display = true;
        this.isDesktop = this.main.isDesktop();
    }

    ngOnInit() {
        this.selectedAction = null;
        this.isAdmin = this.auth.isAdmin()
        this.itemConfirm = new ItemConfirmComponent(this.confirmationService);
        this.listColumns = [
            { header: this.translate.instant('Login_1'), field: 'login', type: 'String', sort: 'login' },
            { header: this.translate.instant('Date'), field: 'dateaction', type: 'DateTime', sort: 'dateaction' },
            { header: this.translate.instant('Info_1'), field: 'datainfo', type: 'String', sort: 'datainfo' },
            { header: this.translate.instant('Action'), field: 'codeaction', type: 'String', sort: null },
            { header: this.translate.instant('&doc_owner'), field: 'username', type: 'String', sort: 'username' }
        ];
        if (this.auth.isAdmin() === true) {
            this.stateList = [
                { label: this.translate.instant('All'), value: null },
                { label: this.translate.instant('Editor'), value: 1 },
                { label: this.translate.instant('Del_Act'), value: 2 },
                { label: this.translate.instant('Delegate'), value: 3 },
                { label: this.translate.instant('Access_Right'), value: 4 },
                { label: this.translate.instant('Query_N'), value: 5 },
                { label: this.translate.instant('Display_N'), value: 6 },
                { label: this.translate.instant('Tag_N'), value: 7 },
                { label: this.translate.instant('Tag_Bsk'), value: 8 },
                { label: this.translate.instant('Req_Bsk'), value: 9 },
                { label: this.translate.instant('Pref_25'), value: 10 },
                { label: this.translate.instant('Load_max'), value: 11 },
                { label: this.translate.instant('Usr_Bsk'), value: 12 },
                { label: this.translate.instant('Cm_menu_N'), value: 13 },
                { label: this.translate.instant('Pref_57'), value: 14 },
                { label: this.translate.instant('Superv_N'), value: 15 },
                { label: this.translate.instant('Res_Bsk'), value: 16 },
            ];
        } else {
            this.stateList = [
                { label: this.translate.instant('Delegate'), value: 3 },
            ];
        }
        this.findAll();
        this.commonService.checkReset();
    }

    private async findAll() {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('getlogtrack',''));
            this.trackLog = wRes.data.data.map((item) => {
                item.dateaction = item.dateaction + '|' + dateFormat(item.dateaction, 'dd/MM/yyyy HH:mm:ss');
                return item;
            });
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Load_Data_KO'));
        }
    }

    public ClickExportExcel() {
        let wExport = [];
        if (this.selectedAction !== null) {
            wExport = this.trackLog.filter(item => {
                return item.codeaction === this.selectedAction
            })
            wExport = prepareExportExcel(this.listColumns, wExport);
        } else {
            wExport = prepareExportExcel(this.listColumns, this.trackLog);
        }
        this.exportExcel('Logs', wExport);
    }

    private async exportExcel(aName, wExport) {
        await this.downloadService.exportExcel(getExportFileName(aName), wExport);
    }

    public clickDateDelLog() {
        this.visible = true;
    }

    public clickDelLog() {
        let wRange = setRangeDate(this.rangeDates);
        if (wRange.empty === true) {
            return;
        }
        this.execDelLog(wRange);
    }

    private async execDelLog(aRange) {
        let wRes: any = {};
        try {
            wRes.data = await lastValueFrom(this.api.execUrlAction('dellogtrack',setFormRangeData(aRange)));
            this.closeDia();
        } catch (error) {
            console.log('Error', error);
            this._messageService.addErrorMsg(this.translate.instant('Delete_KO'));
            this.closeDia();
            return;
        }
        this._messageService.addSuccess(this.translate.instant('Delete_OK'));        
        await this.findAll();
    }

    public closeDia() {
        this.visible = false;
    }    

}
